export type Percentiles = {
  p5?: number;
  p25?: number;
  p50: number;
  p75: number;
  p90?: number;
  p95: number;
  p99?: number;
};

export type DemandPercentiles = {
  active: Percentiles;
  kv?: Percentiles;
};

export type McCurvePercentile = 5 | 25 | 50 | 75 | 95;

export const MC_CURVE_PERCENTILES: McCurvePercentile[] = [5, 25, 50, 75, 95];
